/** @format */

import { Link, Navigate, useNavigate } from "react-router-dom";
import Table from "../../extra/Table";
import Button from "../../extra/Button";
import Title from "../../extra/Title";
import { connect, useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { getSeller, sellerIsBlock, toggleSellerPaidShipping } from "../../store/seller/seller.action";
import { forceLogoutSeller } from "../../store/admin/admin.action";
import ToggleSwitch from "../../extra/ToggleSwitch";
import dayjs from "dayjs";
import Pagination from "../../extra/Pagination";
import Searching from "../../extra/Searching";
import { OPEN_DIALOGUE } from "../../store/dialogue/dialogue.type";
import SellerNotification from "./SellerNotification";
import Skeleton from "react-loading-skeleton";
import { colors } from "../../../util/SkeletonColor";
import "react-loading-skeleton/dist/skeleton.css";
import EditInfo from "../../../assets/images/Edit.png";
import Info from "../../../assets/images/Info.svg";
import Iconb from "../../extra/Iconb";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import NotificationsNoneRoundedIcon from "@mui/icons-material/NotificationsNoneRounded";
import defaultImage from "../../../assets/images/default.jpg";
import InitialsAvatar from "../../extra/InitialsAvatar";

import InfoOutlined from "@mui/icons-material/InfoOutlined";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";

const Seller = (props) => {
	const [size, setSize] = useState(10);
	const [page, setPage] = useState(1);
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);

	const [search, setSearch] = useState("");
	const [currentPage, setCurrentPage] = useState(1);
	const [rowsPerPage, setRowsPerPage] = useState(10);

	const { seller, totalSeller } = useSelector((state) => state.seller);
	const { dialogue, dialogueType, dialogueData } = useSelector((state) => state.dialogue);
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getSeller(currentPage, size));
	}, [dispatch, currentPage, size]);

	useEffect(() => {
		const timer = setTimeout(() => {
			setLoading(false);
		}, 1500); // Adjust the delay time as needed

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		setData(seller);
	}, [seller]);

	// // pagination
	const handleChangePage = (event, newPage) => {
		setCurrentPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event), 10);
		setSize(parseInt(event), 10);
		setCurrentPage(1);
	};

	const handleClick = (sellerDetails) => {
		props.sellerIsBlock(sellerDetails, sellerDetails.isBlock === true ? false : true);
	};

	// Force-logout: bumps the seller's tokenVersion server-side so every active
	// JWT for this seller becomes stale immediately.
	const handleForceLogout = (sellerDetails) => {
		if (!sellerDetails?._id) return;
		const confirmed = window.confirm(`Force logout ${sellerDetails.firstName || "this seller"} from every device?`);
		if (!confirmed) return;
		dispatch(forceLogoutSeller(sellerDetails._id));
	};
	const handleOpen = (id) => {
		// window.location.href = "/admin/userProfile"
		navigate("/admin/sellerProfile", {
			state: id,
		});
	};

	const handleEdit = (id) => {
		navigate("/admin/addSeller", {
			state: id,
		});
	};

	// searching

	const handleFilterData = (filteredData) => {
		if (typeof filteredData === "string") {
			setSearch(filteredData);
		} else {
			setData(filteredData);
		}
	};

	const mapData = [
		{
			Header: "No",
			width: "20px",
			Cell: ({ index }) => <span className='fw-normal'>{(currentPage - 1) * rowsPerPage + index + 1}</span>,
		},
		{
			Header: "Seller",
			body: "firstName",
			Cell: ({ row }) => {
				const fullName = `${row?.firstName || ""} ${row?.lastName || ""}`.trim();
				return loading ? (
					<div className='d-flex align-items-center'>
						<Skeleton circle height={40} width={40} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
						<div className='ms-2'>
							<Skeleton width={120} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
							<Skeleton width={160} baseColor={colors?.baseColor} highlightColor={colors?.highlightColor} />
						</div>
					</div>
				) : (
					<div className='d-flex align-items-center text-start'>
						<InitialsAvatar src={row?.image} name={fullName} size={40} />
						<div className='ms-2'>
							<div className='fw-semibold text-capitalize' style={{ color: "#0f172a", lineHeight: "1.2" }}>
								{fullName || "-"}
							</div>
						</div>
					</div>
				);
			},
			sorting: false,
		},

		{
			Header: "Contact",
			body: "email",
			Cell: ({ row }) => (
				<div className='text-start'>
					<div style={{ color: "#0f172a", lineHeight: "1.2" }}>{row?.email || "-"}</div>
					{row?.mobileNumber && <div style={{ fontSize: "12px", color: "#64748b" }}>{row.mobileNumber}</div>}
				</div>
			),
			sorting: false,
		},
		{
			Header: "Business Name",
			body: "businessName",
			Cell: ({ row }) => <span className='mb-0 fw-normal'>{row?.businessName ? row?.businessName : "-"}</span>,
		},
		{
			Header: "Business Tag",
			body: "businessTag",
			Cell: ({ row }) => <span className='mb-0 fw-normal'>{row.businessTag ? row.businessTag : "-"}</span>,
		},

		{
			Header: "Total Product",
			body: "totalProduct",
			Cell: ({ row }) => <span className='count-badge'>{row.totalProduct ? row.totalProduct : 0}</span>,
		},
		{
			Header: "Total Order",
			body: "totalOrder",
			Cell: ({ row }) => <span className='count-badge'>{row?.totalOrder ? row?.totalOrder : 0}</span>,
		},

		{
			Header: "Block",
			body: "isBlock",
			Cell: ({ row }) => (
				<div className={``}>
					<ToggleSwitch value={row?.isBlock} onClick={() => handleClick(row)} disabled={row?.email === "declotrtest@gmail.com" && true} />
				</div>
			),
		},
		{
			Header: "Paid Shipping",
			body: "paidShippingEnabled",
			Cell: ({ row }) => (
				<div title='Allow buyers to choose Paid Shipping for this seller'>
					<ToggleSwitch value={row?.paidShippingEnabled !== false} onClick={() => dispatch(toggleSellerPaidShipping(row))} />
				</div>
			),
		},
		{
			Header: "Created Date",
			body: "createdAt",
			Cell: ({ row }) => <span className='fw-normal'>{dayjs(row.createdAt).format("DD MMM YYYY")}</span>,
		},
		{
			Header: "Notification",
			body: "",
			Cell: ({ row }) => (
				<button
					className='action-icon-btn'
					onClick={() => {
						dispatch({
							type: OPEN_DIALOGUE,
							payload: { data: row, type: "SellerNotification" },
						});
					}}>
					<NotificationsNoneRoundedIcon sx={{ fontSize: 18 }} />
				</button>
			),
		},
		{
			Header: "Edit",
			body: "",
			Cell: ({ row }) => (
				<button className='action-icon-btn' onClick={() => handleEdit(row)}>
					<CreateOutlinedIcon sx={{ fontSize: 18 }} />
				</button>
			),
		},

		{
			Header: "Info",
			body: "",
			Cell: ({ row }) => (
				<button className='action-icon-btn' onClick={() => handleOpen(row?._id)}>
					<InfoOutlined sx={{ fontSize: 18 }} />
				</button>
			),
		},

		{
			Header: "Sessions",
			body: "",
			Cell: ({ row }) => (
				<button className='action-icon-btn text-danger' title='Force logout from every device' onClick={() => handleForceLogout(row)}>
					<LogoutRoundedIcon sx={{ fontSize: 18 }} />
				</button>
			),
		},

		// add more columns as needed
	];
	return (
		<>
			<div className='mainSellerTable'>
				<div className='sellerTable'>
					<div className='col-12 headname'>Seller </div>

					<div className='sellerMain'>
						<div className='tableMain mt-2'>
							<div className='sellerHeader primeHeader'>
								<div className='row'>
									<div className='col-2'>{dialogue && dialogueType === "SellerNotification" && <SellerNotification />}</div>
									<div className='col-10 text-end'>
										<Searching type={`client`} data={seller} setData={setData} column={data} onFilterData={handleFilterData} serverSearching={handleFilterData} button={true} setSearchValue={setSearch} searchValue={search} />
									</div>
								</div>
							</div>
							<Table data={data} mapData={mapData} serverPerPage={rowsPerPage} serverPage={page} type={"server"} />
							<Pagination component='div' count={totalSeller} type={"server"} onPageChange={handleChangePage} serverPerPage={rowsPerPage} totalData={totalSeller} serverPage={currentPage} setCurrentPage={setCurrentPage} onRowsPerPageChange={handleChangeRowsPerPage} />
						</div>
					</div>
					<div className='sellerFooter primeFooter'></div>
				</div>
			</div>
		</>
	);
};

export default connect(null, { getSeller, sellerIsBlock, toggleSellerPaidShipping })(Seller);
// export default Seller;
